import { useTranslation } from 'next-i18next'

import ResponsiveImage from '~/components/Image/ResponsiveImage'
import { Breakpoint, useScreenBreakPoints } from '~/utils'
import HomRightArrowIcon from '~/components/Icons/svgs/HomRightArrowIcon'
import SVGIcon from '~/components/Icons/svgs/SVGIcon'
import { Link } from '~/components'
import ROUTES from '~/shared/constants/routes.const'
import { useAppDispatch } from '~/redux/hooks'
import { setSubscriptionPackageType } from '~/redux/slices/subscription.slice'
import useCurrentSubscription from '~/subscription/hooks/useCurrentSubscription'

const mediaQuery = [{ screen: '(min-width: 280px)', width: '20px' }]

export function ShowUpgradeTab(): React.ReactElement {
  const { t } = useTranslation('settings')
  const dispatch = useAppDispatch()
  const currentSubscription = useCurrentSubscription()

  const isSmallScreen = useScreenBreakPoints({ lt: Breakpoint.XL })

  const isActiveClass = isSmallScreen ? 'text-black-link' : 'text-black-link'
  const hoverClass = isSmallScreen ? 'text-black-link' : 'text-purple'
  const href = currentSubscription.subscriptionDetails?.discount?.coupon?.name.includes('DNB')
    ? ROUTES.DNB_CAMPAIGN_UNG_PLUS
    : ROUTES.SUBSCRIPTION_PAGE

  const handleClick = (): void => {
    dispatch(setSubscriptionPackageType('family'))
  }

  return (
    <div>
      <Link className="cursor-pointer flex" onClick={handleClick} to={href}>
        <div className="mt-1 flex">
          <li className={`text-sm md:text-md hover:${hoverClass} ${isActiveClass}`}>{t('upgradeSubscription')}</li>
          {isSmallScreen && (
            <ResponsiveImage
              alt={t('subscriptionRedirect')}
              height={20}
              imageClassName="ml-1"
              imageWidths="20"
              mediaQuery={mediaQuery}
              srcKey="subscription/subscription-redirect-icon.png"
              width={20}
            />
          )}
        </div>

        {isSmallScreen && (
          <div className="font-normal flex ml-auto">
            <SVGIcon icon={HomRightArrowIcon} pathClassName="text-black" />
          </div>
        )}
      </Link>
    </div>
  )
}
